module.exports = "<div class=\"tooltip\" (mouseover)=\"info = !info\">\n  <span>?</span>\n  <div *ngIf=\"info\" [class]=\"'info' + ' ' + position\">\n    <p>{{ tip }}</p>\n    <div class=\"point\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tooltip/tooltip.component.html
// module id = ../../../../../src/app/shared/tooltip/tooltip.component.html
// module chunks = 2